<div
  *ngIf="colVm?.columnType === Types.SectionColumnProductInfoType.Strain"
  appScaleDownText
  [scaleEnabled]="!(menu | isPrintMenu)"
  [style.color]="
    ignoreUserSetTextColorAndAutoToLightOrDarkTextColor
      ? (section | textColorBasedOnSectionHeaderBackgroundColor)
      : (menu | productMenuBasicMethod: 'getSectionHeaderTextColor' : section)
  "
  [scaleDownLinkedKey]="section?.id + Types.TextSizeLink.TypeCannabinoid"
  class="section-header-general section-header-strain">
  {{ menu | productMenuBasicMethod: 'getStrainColumnTitle' : colVm }}
</div>
